import React from 'react';

export const name = 'flag-GR';

export const FlagGR = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask
      id="mask0_2_181"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <path d="M24 0H0V24H24V0Z" fill="white" />
    </mask>
    <g mask="url(#mask0_2_181)">
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#EEEEEE"
      />
      <path
        d="M12 8.86875H23.5875C23.2897 7.76578 22.8351 6.71128 22.2375 5.7375H12V8.86875ZM4.52813 21.3891H19.4719C20.5685 20.5155 21.5044 19.4575 22.2375 18.2625H1.7625C2.49565 19.4575 3.43154 20.5155 4.52813 21.3891ZM4.17188 2.90626C3.22688 3.72124 2.41408 4.67793 1.7625 5.74219H4.17188V2.90626ZM12 12V8.86875H7.30313V12H4.17188V8.86875H0.412504C-0.141133 10.9195 -0.141133 13.0805 0.412504 15.1312H23.5875C23.8547 14.1328 24 13.0828 24 12H12ZM12 9.76523e-06C10.3359 9.76523e-06 8.74688 0.342197 7.30313 0.951572V5.7375H12V2.61095H19.4719C17.35 0.917362 14.7149 -0.00345914 12 9.76523e-06Z"
        fill="#338AF3"
      />
    </g>
  </svg>
);
